import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { useEntityByIdOrOriginalId } from '../../../hooks/entity/useEntityByIdOrOriginalId';
import { WorkTimeEntryToCreate } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';

export function useCreateWorkTimeEntrySelectActivityPageActivities(
  workTimeEntryToCreate: WorkTimeEntryToCreate,
  parentActivityId: string | null
): Array<TimeTrackingActivity> {
  const constructionSite = useEntityByIdOrOriginalId(
    EntityName.ConstructionSite,
    workTimeEntryToCreate.constructionSiteId
  );
  const compilations = useEntities(
    EntityName.TimeTrackingActivityCompilation,
    'getByUserGroupId',
    workTimeEntryToCreate.userGroupId
  );
  const activities = useEntities(
    EntityName.TimeTrackingActivity,
    'getByUserGroupId',
    workTimeEntryToCreate.userGroupId
  );
  const firstCompilation = constructionSite
    ? compilations.find((c) => c.id === constructionSite.compilationId)
    : compilations[0];

  return activities.filter((activity) => {
    return (
      firstCompilation &&
      activity.compilationId === firstCompilation.id &&
      activity.parentActivityId === parentActivityId
    );
  });
}
